import { useState, useEffect } from "react";

export function useCarousel(length, interval = 5000) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(
      () => setIndex((i) => (i + 1) % length),
      interval,
    );
    return () => clearInterval(timer);
  }, [length, interval]);

  const goTo = (i) => setIndex(i);
  const prev = () => setIndex((i) => (i - 1 + length) % length);
  const next = () => setIndex((i) => (i + 1) % length);

  return { index, goTo, prev, next };
}
